<template>
    <virtual-list class="layout-gl-list scroll-touch"
        :data-key="'id'"
        :data-sources="groupList"
        :data-component="itemComponent"
        :estimate-size="50"
        :item-class="'layout-gl-list-item'" />
</template>

<script>
import GroupChooseItem from '../../components/group/GroupChooseItem.vue'
import record from '../../modules/store/modules/record'
export default {
    name: 'GroupVirtualList',
    props: {
        groupId: {
            type: Number,
            default() { return -1 }
        },
        groupList: {
            type: Array,
            default() { return [] }
        }
    },
    data() {
        return {
            itemComponent: GroupChooseItem
        }
    }
}
</script>